export const VISIT_STATUS = {
  IDLE: 0,
  NOT_STARTED: 1,
  TIMED_OUT: 2,
  ON_GOING: 3,
  FAILED: 4,
  FINISHED: 5,
};
